//import {required} from "vuelidate/lib/validators";  
import {required, maxLength, minLength, email } from "vuelidate/lib/validators";  
const opersonel = {
    data() {
      return { 
        opersonelData:{   

          //NÜFUS BİLGİLERİ
          Tckimlikno: null,
          Eposta: "",
          Dogumtarihi: "2000-10-10",
          Dogumyeri: "",
          Ad: "",
          Soyad: "",
          Ikinciad: null,
          Ikincisoyad: null,
          Babaadi: null,
          Anaadi: null,
          Medenihalid: null,
          Cinsiyetid: null,
          NufusCuzdanSeriNo: "11111",
     /*     Ncno: null,
          Nkoil: null,
          Nkoilce: null,
          Nkomahkoy: null,
          Nkociltno: null,
          Nkoailesirano: null,
          Nkosirano: null,*/
          Kangrubu: null,
          Uyrukid: null, 

          //İLETİŞİM BİLGİLERİ
          Ceptelefonu: "05311111111",
          Dahilitelefon: null,
          Evtelefon: null,
          Fax: null,
          Kisiselemail: null,
          Adres: null,
          Mailpassword: null,
          İban: null,

          //KADRO
          Emeklisicil: null,
          Geldigikurum: null,
          Kurumsicileski: null,
          Memuriyetbaslamatarihi: null,
          Isebaslamatarihi:null,
          Asalettarihi: null,
          Say2000: null,
          Gorevunvanid: null,
          Unvantipiid: null,
          Unvanalttipid: null,
          Isegirismezuniyettarihi: "2000-10-10",
          PbsAtanmaSekliId: null,
          Oypdurumu: null,
          Adaymemur: false,
          PbsAtanmaTuruId : null, 
          PbsAtanmaMaddesiId : null,
          Defaultbirimid: null,
          Kurumsicili: null,
          EmekliKademeTerfiTarihi: null,
          OdemeDerece: 1,
          OdemeKademe: 1,
          OdemeTerfiTarihi: null,
          KazanilmisHakAyligiDerece: null,
          KazanilmisHakAyligiKademe: null,
          KazanilmisHakAyligiTerfiTarihi: null,
          EmekliDerece: 11,
          EmekliKademe: 11,
          SonGecerlilikTarihi: null,
          AtanmaTarihi: null,
          Aciklama: null

        },  
          FormDataType:{ 

          //NÜFUS BİLGİLERİ 
          Tckimlikno:{FieldName:"Tckimlikno",Field:"input",FieldTitle:"TC Kimlik No",FieldType:"text"}, 
          Dogumtarihi:{FieldName:"Dogumtarihi",Field:"date",FieldTitle:"Doğum Tarihi"},  
          Dogumyeri:{FieldName:"Dogumyeri",Field:"input",FieldTitle:"Doğum Yeri",FieldType:"text"}, 
          Ad:{FieldName:"Ad",Field:"input",FieldTitle:"Ad",FieldType:"text"}, 
          Soyad:{FieldName:"Soyad",Field:"input",FieldTitle:"Soyad",FieldType:"text"}, 
          Ikinciad:{FieldName:"Ikinciad",Field:"input",FieldTitle:"İkinci Ad",FieldType:"text"}, 
          Ikincisoyad:{FieldName:"Ikincisoyad",Field:"input",FieldTitle:"İkinci Soyad",FieldType:"text"}, 
          Babaadi:{FieldName:"Babaadi",Field:"input",FieldTitle:"Baba Adi",FieldType:"text"}, 
          Anaadi:{FieldName:"Anaadi",Field:"input",FieldTitle:"Ana Adi",FieldType:"text"},  
          Medenihalid:{FieldName:"Medenihalid",Field:"combobox",FieldTitle:"Medeni Hali",ComboData:[],ComboDataArray:[],Multiple:false}, 
          Cinsiyetid:{FieldName:"Cinsiyetid",Field:"combobox",FieldTitle:"Cinsiyet",ComboData:[],ComboDataArray:[],Multiple:false}, 
          NufusCuzdanSeriNo:{FieldName:"NufusCuzdanSeriNo",Field:"input",FieldTitle:"Nüf. Cüz. Seri",FieldType:"text"}, 
                    Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle:"Açıklama",FieldType:"text"}, 
        /*  Ncno:{FieldName:"Ncno",Field:"input",FieldTitle:"	Nüf. Cüz. No",FieldType:"text"}, 
          Nkoil:{FieldName:"Nkoil",Field:"input",FieldTitle:"İl",FieldType:"text"}, 
          Nkoilce:{FieldName:"Nkoilce",Field:"input",FieldTitle:"İlçe",FieldType:"text"}, 
          Nkomahkoy:{FieldName:"Nkomahkoy",Field:"input",FieldTitle:"Mah-Köy",FieldType:"text"}, 
          Nkociltno:{FieldName:"Nkociltno",Field:"input",FieldTitle:"Cilt No",FieldType:"text"}, 
          Nkoailesirano:{FieldName:"Nkoailesirano",Field:"input",FieldTitle:"Aile Sıra No",FieldType:"text"}, 
          Nkosirano:{FieldName:"Nkosirano",Field:"input",FieldTitle:"Sıra No",FieldType:"text"}, */
          Kangrubu:{FieldName:"Kangrubu",Field:"combobox",FieldTitle:"Kan Grubu",ComboData:[],ComboDataArray:[],Multiple:false}, 
          Uyrukid:{FieldName:"Uyrukid",Field:"combobox",FieldTitle:"Uyruk",ComboData:[],ComboDataArray:[],Multiple:false}, 

          //İLETİŞİM BİLGİLERİ  
          Ceptelefonu:{FieldName:"Ceptelefonu",Field:"input",FieldTitle:"Cep Telefonu",FieldType:"text"}, 
          Dahilitelefon:{FieldName:"Dahilitelefon",Field:"input",FieldTitle:"Dahili Telefon",FieldType:"text"}, 
          Evtelefon:{FieldName:"Evtelefon",Field:"input",FieldTitle:"Ev Telefonu",FieldType:"text"}, 
          Fax:{FieldName:"Fax",Field:"input",FieldTitle:"Fax",FieldType:"text"}, 
          Eposta:{FieldName:"Eposta",Field:"input",FieldTitle:"Kurumsal E-Posta",FieldType:"text"}, 
          Kisiselemail:{FieldName:"Kisiselemail",Field:"input",FieldTitle:"Kişisel E-Posta",FieldType:"text"},  
          Adres:{FieldName:"Adres",Field:"input",FieldTitle:"İkametgah Adresi",FieldType:"text"}, 
          Mailpassword:{FieldName:"Mailpassword",Field:"input",FieldTitle:"Şifre",FieldType:"text"}, 
          Iban:{FieldName:"Iban",Field:"input",FieldTitle:"Iban",FieldType:"text"}, 

          //KADRO  
          Emeklisicil:{FieldName:"Emeklisicil",Field:"input",FieldTitle:"Emekli Sicil",FieldType:"text"}, 
          Geldigikurum: {FieldName:"Geldigikurum",Field:"input",FieldTitle:"Geldiği Kurum",FieldType:"text"}, 
          Kurumsicileski:{FieldName:"Kurumsicileski",Field:"input",FieldTitle:"Eski Kurum Sicili",FieldType:"text"}, 
          Memuriyetbaslamatarihi:{FieldName:"Memuriyetbaslamatarihi",Field:"date",FieldTitle:"İlk Memuriyet Başlama T."},  
          Isebaslamatarihi:{FieldName:"Isebaslamatarihi",Field:"date",FieldTitle:"Kurumda İlk İşe Başlama Tarihi"},  
          Asalettarihi:{FieldName:"Asalettarihi",Field:"date",FieldTitle:"Asalet Tarihi"},  
          Say2000:{FieldName:"Say2000",Field:"input",FieldTitle:"Say 2000",FieldType:"text"}, 
          AtanmaTarihi:{FieldName:"AtanmaTarihi",Field:"date",FieldTitle:"Atanma Tarihi"},  
          Gorevunvanid:{FieldName:"Gorevunvanid",Field:"combobox",FieldTitle:"Unvan",ComboData:[],ComboDataArray:[],Multiple:false}, 
          Unvantipiid:{FieldName:"Unvantipiid",Field:"combobox",FieldTitle:"Personel Tipi",ComboData:[],ComboDataArray:[],Multiple:false}, 
          Unvanalttipid: {FieldName:"Unvanalttipid",Field:"combobox",FieldTitle:"Personel Alt Tipi",ComboData:[],ComboDataArray:[],Multiple:false}, 
          Isegirismezuniyettarihi:{FieldName:"Isegirismezuniyettarihi",Field:"date",FieldTitle:"İşe giriş İlk Mezuniyet Tarihi"},  
          PbsAtanmaSekliId:{FieldName:"PbsAtanmaSekliId",Field:"combobox",FieldTitle:"Atanma Şekli",ComboData:[],ComboDataArray:[],Multiple:false}, 
          Oypdurumu:{FieldName:"Oypdurumu",Field:"combobox",FieldTitle:"ÖYP Durumu",ComboData:[],ComboDataArray:[],Multiple:false}, 
          Adaymemur:{FieldName:"Adaymemur",Field:"checkbox",FieldTitle:"Aday Memur"},
          PbsAtanmaTuruId :{FieldName:"PbsAtanmaTuruId",Field:"combobox",FieldTitle:"Atanma Türü",ComboData:[],ComboDataArray:[],Multiple:false},
          PbsAtanmaMaddesiId :{FieldName:"PbsAtanmaMaddesiId",Field:"combobox",FieldTitle:"Atanma Maddesi",ComboData:[],ComboDataArray:[],Multiple:false},
          Defaultbirimid:{FieldName:"Defaultbirimid",Field:"combobox",FieldTitle:"Birim",ComboData:[],ComboDataArray:[],Multiple:false},    
          OdemeDerece:{FieldName:"OdemeDerece",Field:"input",FieldTitle:"",FieldType:"text"}, 
          OdemeKademe:{FieldName:"OdemeKademe",Field:"input",FieldTitle:"",FieldType:"text"}, 
          OdemeTerfiTarihi:{FieldName:"OdemeTerfiTarihi",Field:"date",FieldTitle:""},  
          KazanilmisHakAyligiDerece:{FieldName:"KazanilmisHakAyligiDerece",Field:"input",FieldTitle:"",FieldType:"text"}, 
          KazanilmisHakAyligiKademe:{FieldName:"KazanilmisHakAyligiKademe",Field:"input",FieldTitle:"",FieldType:"text"}, 
          KazanilmisHakAyligiTerfiTarihi:{FieldName:"KazanilmisHakAyligiTerfiTarihi",Field:"date",FieldTitle:""},  
          EmekliDerece:{FieldName:"EmekliDerece",Field:"input",FieldTitle:"",FieldType:"text"}, 
          EmekliKademe:{FieldName:"EmekliKademe",Field:"input",FieldTitle:"",FieldType:"text"}, 
          EmekliKademeTerfiTarihi:{FieldName:"EmekliKademeTerfiTarihi",Field:"date",FieldTitle:""},  
          SonGecerlilikTarihi: {FieldName:"SonGecerlilikTarihi",Field:"date",FieldTitle:"Son Geçerlilik Tarihi"}, 
          }  
      } 
    },
    validations:{ 
      FormData: { 
          //NÜFUS BİLGİLERİ
          Tckimlikno: { required, maxLength: maxLength(11), minLength: minLength(11)  },
          Dogumtarihi: {required },
          Dogumyeri: { },
          Ad: { required},
          Soyad: { required},
          Ikinciad: { },
          Ikincisoyad: { },
          Babaadi: { },
          Anaadi: { },
          Medenihalid: { },
          Cinsiyetid: { },
          NufusCuzdanSeriNo: { },
          Aciklama: {},
       /*   Ncno: { },
          Nkoil: { },
          Nkoilce: { },
          Nkomahkoy: { },
          Nkociltno: { },
          Nkoailesirano: { },
          Nkosirano: { },*/
          Kangrubu: { },
          Uyrukid: { }, 

          //İLETİŞİM BİLGİLERİ
          Ceptelefonu: { required },
          Dahilitelefon: { },
          Evtelefon: { },
          Fax: { },
          Kisiselemail: { },
          Eposta: { required, email },
          Adres: { },
          Mailpassword: { },
          Iban: {},

          //KADRO
          Emeklisicil: { },
          Geldigikurum: {},
          Kurumsicileski: { },
          Memuriyetbaslamatarihi: { },
          Isebaslamatarihi: { },
          Asalettarihi: { },
          Say2000: { },
          Gorevunvanid: {},
          Unvantipiid: { required },
          Unvanalttipid: {},
          Isegirismezuniyettarihi: {},
          PbsAtanmaSekliId: { },
          PbsAtanmaTuruId : { }, 
          PbsAtanmaMaddesiId : {},
          Oypdurumu: { },
          Adaymemur: { required },
          Defaultbirimid: {},
          Kurumsicili: {},
          OdemeDerece: {},
          OdemeKademe: {},
          OdemeTerfiTarihi: {},
          KazanilmisHakAyligiDerece: {},
          KazanilmisHakAyligiKademe: {},
          KazanilmisHakAyligiTerfiTarihi: {},
          EmekliDerece: {},
          EmekliKademe: {},
          EmekliKademeTerfiTarihi: {},
          SonGecerlilikTarihi: {},
          AtanmaTarihi: {}


      } 
  },
  created(){


       


  
      

  }
}
export default opersonel